import { InjectionToken } from '@angular/core';
import { Residence, ResidenceSearchOutput } from '@plutus-realty/models/residence';

export type ResidenceLinkBuilder = (residence: Residence | ResidenceSearchOutput) => string;

export const RESIDENCE_LINK_BUILDER = new InjectionToken<ResidenceLinkBuilder>('RESIDENCE_LINK_BUILDER');